import { createRouter, createWebHistory } from 'vue-router';

import HomeView from './views/HomeView.vue';
import LoginView from './views/LoginView.vue';
import AdminView from './views/AdminView.vue';
import ChangePasswordView from './views/ChangePasswordView.vue';
import WecomCallbackView from './views/WecomCallbackView.vue';
import DocumentsView from './views/DocumentsView.vue';
import DocumentEditorView from './views/DocumentEditorView.vue';
import ApprovalTasksView from './views/ApprovalTasksView.vue';
import ApprovalTaskDetailView from './views/ApprovalTaskDetailView.vue';
import ApprovalFlowsView from './views/ApprovalFlowsView.vue';
import PaymentTasksView from './views/PaymentTasksView.vue';
import RepaymentCollectionsView from './views/RepaymentCollectionsView.vue';
import PaymentCorrectionsView from './views/PaymentCorrectionsView.vue';
import LoanOffsetsView from './views/LoanOffsetsView.vue';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/login', name: 'login', component: LoginView },
    { path: '/ops/login', name: 'ops-login', component: LoginView },
    { path: '/admin', name: 'admin', component: AdminView },
    { path: '/documents', name: 'documents', component: DocumentsView },
    { path: '/documents/new/:kind', name: 'document-new', component: DocumentEditorView },
    { path: '/documents/:kind/:id', name: 'document-edit', component: DocumentEditorView },
    { path: '/approval-tasks', name: 'approval-tasks', component: ApprovalTasksView },
    {
      path: '/approval-tasks/:id',
      name: 'approval-task-detail',
      component: ApprovalTaskDetailView,
    },
    { path: '/approval-flows', name: 'approval-flows', component: ApprovalFlowsView },
    { path: '/payment-tasks', name: 'payment-tasks', component: PaymentTasksView },
    {
      path: '/payment-corrections',
      name: 'payment-corrections',
      component: PaymentCorrectionsView,
    },
    {
      path: '/repayment-collections',
      name: 'repayment-collections',
      component: RepaymentCollectionsView,
    },
    { path: '/loan-offsets', name: 'loan-offsets', component: LoanOffsetsView },
    { path: '/change-password', name: 'change-password', component: ChangePasswordView },
    { path: '/auth/wecom/callback', name: 'wecom-callback', component: WecomCallbackView },
  ],
});
